import { StyledTextInput } from 'components/form-components/styled-text-input'
import PropTypes from 'prop-types'
import React from 'react'
import { validators } from 'utils/form'

const { isRequired } = validators

const propTypes = {
  field: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    fieldSetup: PropTypes.shape({ required: PropTypes.bool }).isRequired,
  }).isRequired,
  noValidation: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export function InputField({ field, noValidation, onChange }) {
  return (
    <StyledTextInput
      model={`.${field._id}`}
      name={`${field._id}`}
      onBlur={event => onChange(event.target.value)}
      maxLength={200}
      validators={
        field.fieldSetup.required && !noValidation ? { isRequired } : null
      }
    />
  )
}

InputField.propTypes = propTypes

export default InputField
